import React, { useState, useEffect, useMemo } from "react";
import "./header.less";
import { Drawer, Space, Skeleton, Tooltip } from "antd";
import { lib } from "../index";
import hooks from "@/util/hooks";
import { useFavicon } from "ahooks";
import { UserChannel } from "../util/channel";
import { env } from "@dt/util";
const { useSaasInfo } = hooks;
import { Map } from "immutable";
import {
    UserOutlined,
    CloudDownloadOutlined,
    LogoutOutlined,
    DownOutlined,
    SwapOutlined,
    NotificationOutlined,
    HistoryOutlined,
    MailOutlined,
} from "@ant-design/icons";
import { Popover, Menu, Button, Modal, Dropdown, Badge, Radio, List, message, Avatar, Spin } from "antd";
import axios from "axios";
import InfiniteScroll from "react-infinite-scroller";
import { observer } from "mobx-react";
import { appStore } from "./store";

function createMenuStyle({
    backgroundColor,
    itemColor,
    hoverColor,
    hoverBackgroundColor,
    selectSubColor,
    selectColor,
    selectBackgroundColor,
    selectRightBackgroundColor,
    borderColor,
    logoColor,
    systemSelectColor,
    systemSelectBackgroundColor,
}) {
    var css = `
        .app-menu , .header.top{
            background: ${backgroundColor};
            border-color: ${borderColor};
        }
        .app-menu .logo{
            color: ${logoColor};
        }
        .app-menu .item  {
            color:${itemColor};
        }
        .app-menu .item:hover {
            color:${hoverColor};
            background: ${hoverBackgroundColor};
        }
        .app-menu .item.active-sub , .app-menu .shrink {
            color: ${selectSubColor};
        }
        .app-menu .item.active , .app-menu .shrink {
            color: ${selectColor};
            background : ${selectBackgroundColor};
        }
        .app-menu .item.active:after{
            background: ${selectRightBackgroundColor};
        }
        .app-header .system-list .active , .app-header .system-list div:hover{
            background: ${systemSelectBackgroundColor};
            color: ${systemSelectColor};
        }

    `;
    var style = document.createElement("style");
    style.innerHTML = css;
    document.head.append(style);
}

function SystemSet() {
    let [visible, setVisible] = useState(false);
    let [list, setList] = useState([]);
    let [activeStyle, setActiveStyle] = useState(null);

    function setStyle(item) {
        setActiveStyle(item);
        localStorage[`/styleV2`] = JSON.stringify(item);
        createMenuStyle(item.colors);
        lib.wait(500);
    }

    useEffect(() => {
        axios
            .get("https://maria.yang800.com/api/data/86")
            .then(json => json.data.data)
            .then(list => {
                setList(list);
                if (!localStorage[`/styleV2`] && list.length > 0) {
                    // setStyle(list.sort(() => Math.random() - Math.random())[0]);
                    setStyle(list?.[0]);
                }
            });
        try {
            setStyle(JSON.parse(localStorage[`/styleV2`]));
        } catch (e) {
            // console.error(e);
        }
    }, []);

    return (
        <div className="system-set">
            <span className="set" onClick={() => setVisible(true)}>
                &#xe91e;
            </span>
            <Drawer
                placement="right"
                onClose={() => setVisible(false)}
                open={visible}
                rootClassName="system-set"
                rootStyle={{ top: 56 }}
                mask={false}>
                <div
                    className="system-set"
                    style={{
                        marginTop: "-32px",
                        marginLeft: "-12px",
                        marginRight: "-12px",
                    }}>
                    <h3>皮肤设置</h3>
                    <ul className="style">
                        {list.map((item, index) => (
                            <li
                                key={index}
                                className={activeStyle?.id === item.id ? "checked" : ""}
                                style={{ backgroundColor: item.mainColor }}
                                onClick={() => setStyle(item)}>
                                <div>{item.title}</div>
                            </li>
                        ))}
                    </ul>
                </div>
            </Drawer>
        </div>
    );
}

function Getnotic() {
    let time;
    const [noticPop, setNoticPop] = useState(false);
    let [num, setNum] = useState(0);
    let [newCount, setNewCount] = useState(0);
    let [noticModal, setNoticModal] = useState(false);
    let [isActive, setIsActive] = useState(0);
    let [hasMore, setHasMore] = useState(true);
    let [loading, setLoading] = useState(false);
    const [type, setType] = useState([]);
    const [msgUidList, setMsgUidList] = useState([]);
    const [menuCheck, setMenuCheck] = useState(["0"]);
    const [readIndex, setReadIndex] = useState(0);
    const [noticDetail, setNoticDetail] = useState({});

    const [readType, setReadType] = useState(null);
    const [currentPage, setCurrentPage] = useState(1);
    const [config, setConfig] = useState(Map({ readType: null, currentPage: 1, menuCheck: ["0"] }));
    const [pageList, setPageList] = useState([]);
    const [isListInto, setIsListInto] = useState(false);
    const [readListIndex, setReadListIndex] = useState(null);
    const [nextFlag, setNextFlag] = useState(false);

    const [total, setTotal] = useState(0);
    useEffect(() => {
        getNoticType();
        setNextFlag(false);
        lib.request({
            url: "/ucenter-config/notice/type/list",
            // success: (data) => console.log(data),
        });
        lib.request({
            url: "/ucenter-account/current/message/listener",
            success: data => {
                setNum(data.newCount);
                setMsgUidList(data.messageUidList);
                // setNewCount(data.newCount);
                if (lib.getParam("formLogin") && data.messageUidList.length > 0) {
                    setNoticModal(true);
                    getNoticType();
                    readDetail(data.messageUidList[0]);
                }
            },
        });
        getPage();
        time = setInterval(() => {
            getNoticNum();
        }, 100000);
        return () => {
            clearInterval(time);
        };
    }, []);
    useEffect(() => {
        setPageList([]);
        setCurrentPage(1);
        // getPage();
    }, [readType]);

    function getNoticType() {
        lib.request({
            url: "/ucenter-account/current/message/type",
            success: data => {
                setType(data);
            },
        });
    }

    function readDetail(uid = "") {
        if (uid) {
        } else {
            uid = msgUidList[readIndex];
        }
        // console.log(uid, "uid", msgUidList, "msgUidList");
        if (msgUidList.length == readIndex + 1) {
            setNextFlag(true);
        } else {
            setNextFlag(false);
        }
        if (!uid) {
            message.error("暂无更多消息");
            return;
        }
        lib.request({
            url: "/ucenter-account/current/message/readDetail",
            data: {
                uid: uid,
            },
            success: data => {
                // console.log(data);
                setNoticDetail(data);
                setReadIndex(readIndex + 1);
            },
        });
    }

    function readDetailOfList() {
        // console.log(pageList, "readListIndex", readListIndex);
        if (readListIndex != null) {
            if (pageList.length == readListIndex + 1) {
                setNextFlag(true);
            } else {
                setNextFlag(false);
            }
            if (pageList[readListIndex]) {
                lib.request({
                    url: "/ucenter-account/current/message/readDetail",
                    data: {
                        uid: pageList[readListIndex].uid,
                    },
                    success: data => {
                        setNoticDetail(data);
                    },
                });
            } else {
                message.error("暂无更多消息");
            }
        }
    }

    useEffect(() => {
        readDetailOfList();
        getNoticType();
    }, [readListIndex]);

    function getNoticNum() {
        lib.request({
            url: "/ucenter-account/current/message/listener",
            success: data => {
                setNum(data.newCount);
                setMsgUidList(data.messageUidList);
                // setNewCount(data.newCount);
            },
        });
    }

    function getNoticDetail(item, index) {
        let newArr = [...pageList];
        newArr[index].readStatus = 1;
        setPageList(newArr);
        setIsListInto(true);
        setReadListIndex(index);
        setNoticModal(true);
        getNoticType();
        getNoticNum();
    }

    function readNotic() {
        lib.request({
            url: "/ucenter-account/current/message/readConfirm",
            data: {
                msgUidList: msgUidList,
            },
            success: data => {
                setNoticDetail(data);
                if (msgUidList.length == 0) {
                    getNoticType();
                }
                getNoticNum();
                getNoticType();
                getPage();
            },
        });
    }

    function getPage() {
        //默认初始化的请求，死方法少用  正常1请求用下面的feachData
        // console.log(menuCheck, "type", type);
        // if (type[menuCheck]) {
        lib.request({
            url: "/ucenter-account/current/message/page",
            data: {
                typeCode: type[menuCheck] ? type[menuCheck].id : "system",
                readStatus: config.get("readType"),
                currentPage: 1,
                pageSize: 10,
            },
            success: data => {
                setTotal(data.page.totalCount);
                if (data.dataList >= data.page.totalCount) {
                    setHasMore(false);
                }
                if (currentPage == 1) {
                    setPageList(data.dataList);
                } else {
                    setPageList(pageList.concat(data.dataList));
                }
            },
        });
        // }
    }

    // useEffect(() => {
    //   console.log("DASDSS")
    //   getPage();
    //   getNoticType()
    //   setConfig((config) => {
    //     config = config.update("currentPage", (value) => 1);
    //     return config;
    //   });
    // }, [menuCheck]);

    function onLoadMore() {
        if (pageList.length >= total) {
            setHasMore(false);
        } else {
            setHasMore(true);
            setConfig(config => {
                config = config.update("currentPage", value => value + 1);
                return config;
            });
        }
    }

    function fetchData() {
        setLoading(true);
        let menuCheck = config.get("menuCheck");
        if (!type[menuCheck]) return;
        lib.request({
            url: "/ucenter-account/current/message/page",
            data: {
                typeCode: type[menuCheck].id,
                readStatus: config.get("readType"),
                currentPage: config.get("currentPage"),
                pageSize: 10,
            },
            success: data => {
                setLoading(false);
                setTotal(data.page.totalCount);
                if (config.get("currentPage") == 1) {
                    setPageList(data.dataList);
                    setHasMore(!(data.dataList.length >= data.page.totalCount));
                } else {
                    setPageList(pageList => {
                        let list = pageList.concat(data.dataList);
                        setHasMore(!(list.length >= data.page.totalCount));
                        return list;
                    });
                }
                // setInitLoading(false)
            },
        });
    }

    useEffect(() => {
        let menuCheck = config.get("menuCheck");
        getNoticType();
        // console.log(type, type[menuCheck])
        if (!type[menuCheck]) return;
        if (config.get("currentPage") == 1) {
            setPageList([]);
        }
        fetchData();
    }, [config]);

    function getHtml() {
        var html = { __html: noticDetail.content ? noticDetail.content : "" };
        if (noticDetail.content) {
            return <div dangerouslySetInnerHTML={html}></div>;
        } else {
            return <div></div>;
        }
    }

    return (
        <div className="system-set">
            <Popover
                arrowPointAtCenter={true}
                overlayStyle={{ minWidth: 550, top: "20px" }}
                overlayClassName="notice-popover"
                placement="bottomRight"
                title={<div style={{ padding: "16px 0 16px 24px", fontSize: 16, fontWeight: 500 }}>消息盒子</div>}
                content={
                    <>
                        <div className="notice">
                            <div className="notice-left">
                                <div style={{ maxHeight: 300, overflow: "auto" }}>
                                    <Menu
                                        onClick={e => {
                                            // getNoticType();
                                            // setMenuCheck([e.key]);
                                            // setCurrentPage(1);
                                            // setPageList([]);
                                            // setHasMore(true)
                                            setConfig(config => {
                                                config = config.set("menuCheck", [e.key]);
                                                config = config.set("currentPage", 1);
                                                // config = config.set("readType", null)
                                                return config;
                                            });
                                        }}
                                        items={type.map((item, index) => {
                                            return {
                                                label: (
                                                    <>
                                                        {item.name}
                                                        <Badge count={item.newCount}></Badge>
                                                    </>
                                                ),
                                                key: index,
                                            };
                                        })}
                                        selectedKeys={config.get("menuCheck")}
                                    />
                                </div>
                                <div
                                    style={{
                                        cursor: "pointer",
                                        display: "flex",
                                        flexDirection: "row",
                                        justifyContent: "center",
                                        alignItems: "center",
                                    }}
                                    onClick={() => {
                                        readNotic();
                                    }}
                                    className="allRead">
                                    <MailOutlined style={{ color: "#666" }} />{" "}
                                    <span style={{ color: "#666", marginLeft: 8 }}>全部已读</span>
                                </div>
                            </div>
                            <div className="notice-right">
                                <div className="buttonBox">
                                    <div
                                        className={isActive == 0 ? "active" : "btn"}
                                        onClick={() => {
                                            setIsActive(0);
                                            setConfig(config => {
                                                config = config.set("readType", null);
                                                config = config.set("currentPage", 1);
                                                return config;
                                            });
                                            // setReadType(null);
                                            // setHasMore(true)
                                        }}>
                                        全部消息
                                    </div>
                                    <div
                                        className={isActive == 1 ? "active" : "btn"}
                                        onClick={() => {
                                            setIsActive(1);
                                            setConfig(config => {
                                                config = config.set("readType", 0);
                                                config = config.set("currentPage", 1);
                                                return config;
                                            });
                                            // setHasMore(true)
                                        }}>
                                        未读消息
                                    </div>
                                    <div
                                        className={isActive == 2 ? "active" : "btn"}
                                        onClick={() => {
                                            setIsActive(2);
                                            // setReadType(1);
                                            setConfig(config => {
                                                config = config.set("readType", 1);
                                                config = config.set("currentPage", 1);
                                                return config;
                                            });
                                            // setHasMore(true)
                                        }}>
                                        已读消息
                                    </div>
                                </div>
                                <div className="scroll_list demo-infinite-container">
                                    <InfiniteScroll
                                        initialLoad={false}
                                        pageStart={0}
                                        loadMore={onLoadMore}
                                        hasMore={hasMore && !loading}
                                        useWindow={false}>
                                        <List
                                            dataSource={pageList}
                                            renderItem={(item, index) => (
                                                <List.Item
                                                    style={{ cursor: "pointer", height: "40px" }}
                                                    onClick={getNoticDetail.bind(this, item, index)}
                                                    key={index}>
                                                    <Badge
                                                        className="badge"
                                                        color={!item.readStatus ? "#f50" : "#fff"}
                                                        text={item.title}
                                                    />
                                                </List.Item>
                                            )}>
                                            {loading && hasMore && (
                                                <div className="demo-loading-container">
                                                    <Spin />
                                                </div>
                                            )}
                                        </List>
                                    </InfiniteScroll>
                                </div>
                            </div>
                        </div>
                    </>
                }
                trigger="click">
                <Badge
                    onClick={() => {
                        getPage();
                        getNoticType();
                    }}
                    count={num}
                    offset={[5, 15]}>
                    <span className="set">&#xe7c4;</span>
                </Badge>
            </Popover>
            <Modal
                title="系统公告"
                width={800}
                bodyStyle={{ padding: 0, overflow: "auto", maxHeight: 450 }}
                open={noticModal}
                onCancel={() => {
                    setNoticModal(false);
                }}
                footer={[
                    isListInto ? (
                        <Button
                            key="back"
                            disabled={nextFlag}
                            onClick={() => {
                                setReadListIndex(readListIndex + 1);
                                // getNoticType();
                            }}>
                            下一条
                        </Button>
                    ) : (
                        <Button
                            key="back"
                            disabled={nextFlag}
                            onClick={() => {
                                readDetail();
                                getNoticType();
                            }}>
                            下一条
                        </Button>
                    ),
                    <Button
                        key="submit"
                        type="primary"
                        onClick={() => {
                            setNoticModal(false);
                        }}>
                        我知道了
                    </Button>,
                ]}>
                <p style={{ background: "#EAF7FE", padding: 5 }}>
                    <Space style={{ color: "#609FE6", marginLeft: 20 }} size="middle">
                        <span>
                            <NotificationOutlined /> 公告类型：
                            {noticDetail.categoryName ? noticDetail.categoryName : ""}
                        </span>
                        <span>
                            <HistoryOutlined /> 发布时间： {noticDetail.publishTime ? noticDetail.publishTime : ""}
                        </span>
                    </Space>
                </p>
                <h2 style={{ marginLeft: 20 }}>{noticDetail.title ? noticDetail.title : ""}</h2>
                <div style={{ marginLeft: 20 }} className="htmlBox">
                    {getHtml()}
                </div>
            </Modal>
            {/* <Drawer
        placement="right"
        onClose={() => setVisible(false)}
        visible={visible}
        className="system-set"
        style={{ top: 56 }}
        mask={false}
      >
        <div
          className="system-set"
          style={{
            marginTop: "-32px",
            marginLeft: "-12px",
            marginRight: "-12px",
          }}
        >
          <h3>皮肤设置</h3>
          <ul className="style">
            {list.map((item, index) => (
              <li
                key={index}
                className={activeStyle?.id === item.id ? "checked" : ""}
                style={{ backgroundColor: item.mainColor }}
                onClick={() => setStyle(item)}
              >
                <div>{item.title}</div>
              </li>
            ))}
          </ul>
        </div>
      </Drawer> */}
        </div>
    );
}

function ChangeAccount() {
    let [list, setList] = useState([]);
    let [visible, setVisible] = useState(false);
    useEffect(() => {
        lib.request({
            url: "/ucenter-account/current/masterUserList",
            success: data => setList(data),
        });
    }, []);

    return (
        list?.length > 1 && (
            <>
                <div className="item" onClick={() => setVisible(true)}>
                    <SwapOutlined style={{ marginRight: "10px" }} />
                    切换账号
                </div>
                <Drawer
                    placement="right"
                    onClose={() => setVisible(false)}
                    open={visible}
                    closable
                    rootClassName="react-single-app-change-account"
                    rootStyle={{ top: 56 }}
                    mask={false}>
                    <div className="title">切换账号</div>
                    {list.map(item => (
                        <div
                            className={`item ${item.active && "active"}`}
                            key={item.id}
                            onClick={() => {
                                if (!item.active) {
                                    lib.request({
                                        url: "/ucenter-account/token/login",
                                        data: {
                                            masterUserName: item.name,
                                        },
                                        needMask: true,
                                        success: () => {
                                            let currentSystemPath =
                                                window.location.pathname.match(/\/([a-z]|-)*\//)?.[0];
                                            window.location = window.location.origin + currentSystemPath;
                                        },
                                    });
                                }
                            }}>
                            {" "}
                            {item.name}
                        </div>
                    ))}
                </Drawer>
            </>
        )
    );
}

function User() {
    let [name, setName] = useState("");
    let [systemList, setSystemList] = useState([]);
    let [user, setUser] = useState("");
    useEffect(() => {
        lib.request({
            url: "/ucenter-account/current/userInfo",
            success: data => {
                setUser(data);
                setName(data.userName);
                appStore.userInfo = data;
                localStorage["userInfo"] = JSON.stringify(data);
                lib.setSession("userData", data);
            },
        });
        // 获取账号列表
        lib.request({
            url: "/ucenter-account/current/masterUserList",
            needMask: false,
            success: data => setSystemList(data),
        });
    }, []);
    const items = [
        {
            label: (
                <div className="item" onClick={() => lib.openPage("/personal-center?page_title=个人中心")}>
                    <UserOutlined style={{ marginRight: "10px" }} />
                    个人中心
                </div>
            ),
        },
        {
            label: (
                <div className="item" onClick={() => lib.openPage("/download-center?page_title=下载中心")}>
                    <CloudDownloadOutlined style={{ marginRight: "10px" }} />
                    下载中心
                </div>
            ),
        },
        {
            label: (
                <div
                    className="item logout"
                    onClick={() => {
                        lib.request({
                            url: "/ucenter-account/logout",
                            data: { systemCode: lib.config.systemCode },
                            success: () => window.location.reload(),
                        });
                        ["127.0.0.1", "localhost"].includes(location.hostname) && lib.setCookie("token", "");
                    }}>
                    <LogoutOutlined style={{ marginRight: "10px" }} />
                    退出登录
                </div>
            ),
        },
    ];

    // 切换主账号
    function locationHandle(system) {
        lib.request({
            url: "/ucenter-account/token/login",
            needMask: false,
            data: { masterUserName: system.name },
            success: () => {
                const { isAdmin, isWMS, isUser } = env;
                let role = isAdmin ? "admin" : isWMS ? "wms" : isUser ? "user" : "";

                window.location.reload();
                // 发送消息给其他页面
                UserChannel.postMessage({
                    type: "warehouseChange",
                    data: {
                        masterUserId: system.id,
                        masterUserName: system.nickName,
                        role,
                    },
                });
            },
        });
    }
    return (
        <div className="user">
            <div className="manage-system">
                {systemList && systemList.length > 0 && (
                    <Popover
                        placement="top"
                        content={systemList.map((system, key) => {
                            return (
                                <div className="item" key={key} onClick={() => locationHandle(system)}>
                                    {system.nickName}
                                </div>
                            );
                        })}
                        overlayClassName="react-single-app-popover">
                        {systemList.map((system, key) => {
                            return (
                                system.active == true && (
                                    <span style={{ margin: "15px" }}>
                                        {system.nickName} <DownOutlined />
                                    </span>
                                )
                            );
                        })}
                    </Popover>
                )}
            </div>
            <Dropdown menu={{ items }} arrow placement="bottomLeft" overlayClassName="react-single-app-user">
                <div className={"shopName"}>{name}</div>
            </Dropdown>
        </div>
    );
}

function Header() {
    const [sassInfo, loading] = useSaasInfo();
    useFavicon(sassInfo?.logo);
    if (sassInfo.systemName) document.title = sassInfo.systemName;
    return (
        <div className="app-header">
            {loading ? (
                <Skeleton
                    avatar
                    paragraph={{
                        rows: 0,
                    }}
                    className="skeleton-logo"
                />
            ) : (
                <div className="logo">
                    <img src={`${sassInfo.logo}`} />
                    <Tooltip title={sassInfo.systemName} className="logo-title">
                        {sassInfo.systemName}
                    </Tooltip>
                </div>
            )}

            <HeaderLinks appStore={appStore} />
            <User />
            <Getnotic />
            <SystemSet />
        </div>
    );
}

const HeaderLinks = observer(({ appStore }) => {
    const [systemList, setSystemList] = useState([]);
    useEffect(() => {
        getSystemList();
    }, []);

    async function getSystemList() {
        const list = await lib.request({
            url: "/ucenter-account/current/user/systemList",
        });

        // 如果是用户角色，过滤掉 TICKET_WEB 系统
        const filteredList =
            lib.config.webToken === "user" ? list.filter(system => system.systemCode !== "TICKET_WEB") : list;

        setSystemList(filteredList);
    }

    return (
        <div className="system-list">
            {systemList?.map(system => (
                <div
                    key={system.systemCode}
                    onClick={() => {
                        lib.request({
                            data: { systemCode: system.systemCode },
                            url: "/ucenter-account/current/updateLastLoginSystem",
                        });
                        setTimeout(() => {
                            window.open(system.url);
                        }, 200);
                    }}
                    className={system.systemCode == lib.config.systemCode ? "active" : ""}>
                    {system.name}
                </div>
            ))}
        </div>
    );
});

export default Header;
